import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=6660e593&scoped=true"
import script from "./FaqPage.vue?vue&type=script&lang=js"
export * from "./FaqPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6660e593",
  null
  
)

export default component.exports